/**
 * Workspace image rules, shared by every path that can supply a file (the file
 * picker and drag-and-drop). Mirrors the server-side allow-list in
 * workspaces.service.ts (IMAGE_MIME_EXT) and the 2 MB interceptor limit — the
 * backend stays the source of truth; this only spares the user a round-trip.
 */
export const MAX_IMAGE_BYTES = 2 * 1024 * 1024;

/** `accept` attribute for the file input, and the mime allow-list. */
export const IMAGE_TYPES = 'image/png,image/jpeg,image/webp,image/gif';

const ALLOWED_MIMES = IMAGE_TYPES.split(',');

/** Returns an error message, or null when the file is acceptable. */
export function validateWorkspaceImage(file) {
  if (!file) return 'No image selected';
  if (!ALLOWED_MIMES.includes(file.type)) return 'Use a PNG, JPEG, WebP or GIF image';
  if (file.size > MAX_IMAGE_BYTES) return 'Image must be 2 MB or smaller';
  return null;
}
